
  export default {
    props: {
      items: {
        type: Array,
        default() {
          return []
        }
      },
      disabled: {
          type: Boolean,
          default: false
      }
    },
    methods: {
      toggle (close = false) {
        this.$el.lastChild.classList.toggle('hide')
        this.$el.firstChild.classList.toggle('hide')
      }
    }
  }
